import { faChevronLeft } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@mui/material";
import DefaultButton from "../../../../../components/Accessibility/DefaultButton";
import { StepRevisaoFinalizacaoExecutivoProps } from "../../../../../interfaces/props/Financeiro/Reembolso/StepRevisaoFinalizacaoExecutivo";
import { useAccessibility } from "../../../../../Store/contexts/AccessibilityContext";
import { sxDarkGreyBody } from "../../../../MeuPlano/PermissoesVisualizacao/sxProps";
import AttachmentsCard from "../AttachmentsCard";
import TotalValueCard from "../TotalValueCard";
import ExecutiveAccountDataCard from "./ExecutiveAccountDataCard";
import ExecutiveBenefDataCard from "./ExecutiveBenefDataCard";
import './styles.css';

const StepRevisaoFinalizacaoExecutivo: React.FC<StepRevisaoFinalizacaoExecutivoProps> = ({
  handleBack, handleProceed, handleEditInfos, resumoReembolsoExecutivo, anexos, benef, cel, email
}) => {

  const accessibility = useAccessibility();

  return (
    <div className="feature-container">
      <Typography style={accessibility.textStyleAccessibility} sx={sxDarkGreyBody}>Revise os dados do seu reembolso:</Typography>
      <ExecutiveBenefDataCard nome={benef}
        telefone={cel}
        email={email}
      />
      <ExecutiveAccountDataCard
        agencia={resumoReembolsoExecutivo?.agencia} banco={resumoReembolsoExecutivo?.banco} cpfTitular={resumoReembolsoExecutivo?.cpfTitularConta}
        numConta={resumoReembolsoExecutivo?.numConta} tipoConjConta={resumoReembolsoExecutivo?.conta} tipoConta={resumoReembolsoExecutivo?.tipoConta}
        titularConta={resumoReembolsoExecutivo?.titularConta}
      />
      <AttachmentsCard anexos={anexos || []} />
      <TotalValueCard totalValue={resumoReembolsoExecutivo?.valorTotalGasto || ''} />
      <div className="executive-refund-buttons">
        <DefaultButton
          variant="outlined"
          onClick={handleEditInfos}
          disabled={false}
          text="Editar informações"
        />
        <DefaultButton
          variant="contained"
          disabled={false}
          onClick={handleProceed}
          text="Enviar"
        />
      </div>
      <button className="back-button" style={accessibility.textStyleAccessibility} onClick={() => handleBack()} aria-label="Voltar para anexos e motivos">
        <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
      </button>
    </div>
  )
}

export default StepRevisaoFinalizacaoExecutivo;